module.exports = __webpack_public_path__ + "static/media/lagan.a5cb55f1.png";